const formatNumber = (num) => {
  if (!num) return ''
  // Remove non-digit characters and format with thousands separators
  if (typeof num === 'number') {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  } else {
    const cleanValue = num?.replace(/\D/g, '')
    return cleanValue.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
  }
}

export default formatNumber
